var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"items":_vm.areaList,"label":"违章区域","prepend-icon":"$vuetify.icons.location","value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }